import PropTypes from 'prop-types'
import React from 'react'
import { cn } from '../modules'

function NewsListItemText({
  title,
  featured,
  badge,
  timestamp,
  image,
  className,
  active,
}) {
  if (featured) {
    return (
      <div
        className={cn(
          'relative aspect-video sm:max-h-[30vw] lg:max-h-max w-full flex items-start rounded-lg text-white',
          '[a_&]:active:ring-2 [a_&]:active:ring-offset-2 [a_&]:active:ring-theme-500',
          '[button_&]:active:ring-2 [button_&]:active:ring-offset-2 [button_&]:active:ring-theme-500',
          active && 'ring-2 ring-offset-2 ring-theme-500',
          className,
        )}
        title={title}
      >
        <div
          style={{
            '--news-list-item__image': image ? `url(${image})` : 'url("")',
          }}
          className={cn(
            'w-full h-full flex-none rounded-lg bg-cover bg-center bg-theme-500 news-list-item-text__featured-image',
            '[a_&]:group-active:ring-2 [a_&]:group-active:ring-offset-2 [a_&]:group-active:ring-theme-500',
            '[button_&]:group-active:ring-2 [button_&]:group-active:ring-offset-2',
            '[button_&]:group-active:ring-theme-500',
            active && 'ring-2 ring-offset-2 ring-theme-500 news-list-item-text__featured-image--active',
          )}
        />
        <div className="absolute p-4 flex flex-col items-start space-y-2">
          {badge}
          <div className="flex flex-col">
            <div className="line-clamp-3 font-display font-extrabold leading-normal break-words text-h5">
              {title}
            </div>
            <div className="text-xs opacity-80 font-black pt-1">{timestamp}</div>
          </div>
        </div>
      </div>
    )
  }
  return (
    <div className={cn('group w-full flex items-start', className)} title={title}>
      <div
        style={{
          '--news-list-item__image': image ? `url(${image})` : 'url("")',
        }}
        className={cn(
          'w-[100px] h-[100px] sm:w-[200px] sm:h-[200px] lg:w-[100px] lg:h-[100px] flex-none rounded-lg bg-cover',
          '[a_&]:group-active:ring-2 [a_&]:group-active:ring-offset-2 [a_&]:group-active:ring-theme-500',
          '[button_&]:group-active:ring-2 [button_&]:group-active:ring-offset-2 [button_&]:group-active:ring-theme-500',
          'bg-theme-500 bg-center news-list-item-text__image',
          active && 'ring-2 ring-offset-2 ring-theme-500 news-list-item-text__image--active',
        )}
      />
      <div className={cn('pl-4 flex flex-col items-start space-y-2', badge && 'pt-1')}>
        {badge}
        <div className="flex flex-col">
          <div className="line-clamp-2 font-display font-extrabold leading-normal break-words text-base">
            {title}
          </div>
          <div className="text-xs text-gray-500 font-black pt-1">{timestamp}</div>
        </div>
      </div>
    </div>
  )
}

NewsListItemText.propTypes = {
  title: PropTypes.string.isRequired,
  badge: PropTypes.element,
  featured: PropTypes.bool,
  active: PropTypes.bool,
  image: PropTypes.string,
  timestamp: PropTypes.string,
  className: PropTypes.string,
}

NewsListItemText.defaultProps = {
  badge: null,
  featured: false,
  active: false,
  image: null, // TODO Should use a placeholder image we need image resolving of component lib images in clients
  timestamp: null,
  className: null,
}

export default NewsListItemText
